import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import { NotificationModel, PushNotificationService, AuthService, UploadService } from "@bt/core";
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import * as $ from 'jquery';
import { Router, ActivatedRoute } from "@angular/router";
import { FormArray, FormGroup, FormBuilder, Validators, FormsModule, AbstractControl } from "@angular/forms";
import { DomainModel, DomainService, LegalDomainService, UserService, GeoService, LegalDomainModel} from "@bt/core";

import { environment } from "@bt/environments";
const apiUrl = environment.apiUrl;


@Component({
  selector: "app-push-notification-editor",
  templateUrl: "./push-notification-editor.component.html",
  styleUrls: ["./push-notification-editor.component.scss"]
})
export class PushNotificationEditorComponent extends BaseComponent implements OnInit {

  public sectionHead: string ;
  public notificationModel: NotificationModel;
  public newNotificationForm: FormGroup;
  public notificationTypeOptions: any = [];
  public notificationGeoOptions: any = [];
  public btFileInfo1click: boolean = false;
  public isloadedbtFileInfo1: boolean = false;
  public isloadedbtFileInfo2: boolean = false;
  public btFileInfo2click: boolean = false;
  public linkIsInvalid: boolean = false;
  public newbtFileInfo1: any;
  public newbtFileInfo2: any;
  public domains: any = [];
  public iconSizeError: boolean = false;
  public imageSizeError: boolean = false;
  public selectDomains: boolean = false;
  public legalDoamins: LegalDomainModel[];
  public accessFormat: string[] = [
    "image/jpeg",
    "image/png",
    // "image/gif" не поддерживается в пуш уведомлениях
  ];

  notifier: any;

  constructor(
    private pushNotificationService: PushNotificationService,
    private uploadService: UploadService,
    private notifierService: NotifierService,
    private router: Router,
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private geoService: GeoService,
    private userService: UserService,
    private domainService: DomainService,
    private cdRef:ChangeDetectorRef,
    private legalDomainService: LegalDomainService,
  ) {
    super();
    this.sectionHead=this.activeRoute.snapshot.data['sectionHead'];
    this.notifier = notifierService;
  }

  public ngOnInit () {
    this.notificationModel = new NotificationModel();
    this.GetGeos();
    this.GetLegalDomain();
    
    let me = this;

    function pushLinkValidator(control: AbstractControl): { [key: string]: boolean } | null {
      if (!!control.value  && isNaN(control.value)) {
        for(var i = 0; i < me.legalDoamins.length; i++){
          if (control.value.indexOf(me.legalDoamins[i].name) != -1){
            return null;
          }
        };
      }
      return { 'illegalLink': true };
    }

    this.newNotificationForm = this.fb.group({
      headTextNotification: ["", [Validators.required, Validators.maxLength(50), Validators.minLength(5)]],
      textNotification: ["", [Validators.maxLength(120)/*, Validators.required, Validators.minLength(10)*/]],
      linkNotification: ["", [Validators.required, pushLinkValidator]],
      typeNotification: ["", [Validators.required]],
      beginDateForSendNotification: ["", [Validators.required]],
      timeLiveNotification: ["", [Validators.required, Validators.min(-1), Validators.pattern(this.integerPattern)]],
      btFileInfo1Notification: [""],
      btFileInfo2Notification: [""],
      btFileInfo1Name: ["", [Validators.required]],
      btFileInfo2Name: [""],
      hourNotification: ["", [Validators.required]],
      nidNotification: ["", [Validators.required, Validators.maxLength(120)]],
      ttlNotification: ["", [Validators.required, Validators.min(0), Validators.max(672), Validators.pattern(this.integerPattern)]],
      geoNotification: ["", [Validators.required]],

    });

    this.notificationTypeOptions = [
      { value: 0, name: "News", code: "", label: "Новости" },
      { value: 1, name: "Product", code: "", label: "Продукт" },
    ];

    function setStyle() {
      if ((<any>window).$(".my-selectize-input .selectize-control .selectize-input").val() != undefined) {
        var t = (<any>window).$(".my-selectize-input .selectize-control .selectize-input");
        t.css({
          'width': '100%',
          'padding': '5px 0px',
          'margin': '0',
          'background': 'inherit',
          'color': 'black',
          'border': 'none',
          'border-bottom': '1px solid',
          'line-height': '19px',
          'margin-bottom': '15px'
        });
      }
      else {
        setTimeout(setStyle, 100);
      }

    }
    setStyle();
  }

  GetGeos(){
    this.setLoading(true);
    this.geoService.GetGeos()
    .then((resp) => {
      // this.notificationGeoOptions.push({label:"Все Гео",value: "0"});

      for(let geo of resp.data){
        this.notificationGeoOptions.push({label: geo.name, value: geo.id});
      }
      this.setLoading(false);
      this.getOrCreateNotif();
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении элементов Гео");
    });
  }

  getOrCreateNotif(){
    var id = this.activeRoute.snapshot.paramMap.get('id');
    if (id) {
      this.loadNotification(id);
    }
    else {
      this.GetDomains();

      this.notificationModel.type = 0;
      this.notificationModel.geoId = Math.min(...this.notificationGeoOptions.map(x => x.value));
      this.notificationModel.timeLive = 1;
      this.notificationModel.ttl = 672;
      this.notificationModel.defaultDomains = true;

      var today = new Date();
      var dd = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var mmStr=mm.toString(), ddStr=dd.toString();
      if (dd < 10) {
        ddStr = '0' + dd;
      }

      if (mm < 10) {
        mmStr = '0' + mm;
      }
      this.notificationModel.beginDateForSend  = yyyy+'-' +mmStr + '-' + ddStr;
      hour < 10 ? this.notificationModel.time = "0"+hour : this.notificationModel.time = hour.toString();
      minute < 10 ? this.notificationModel.time = this.notificationModel.time+":0"+minute : this.notificationModel.time = this.notificationModel.time+":"+minute ;
    }
  }

  public changeProductType(event){
     if (event == 1) 
       this.nidNotification.disable();
     else 
       this.nidNotification.enable();
  }

  GetLegalDomain(){
    this.setLoading(true);
    this.legalDomainService.GetLegalDomain()
    .then((resp) => {
      this.legalDoamins = resp.data;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении списка доменов");

      this.setLoading(false);
    });
  }

  defaultOrSelectDomais(defOrSel: boolean){

    if(defOrSel){
      this.domains.forEach(domain => {
        domain.selected = true;
      });
      this.notificationModel.defaultDomains = true;
      this.selectDomains = false;
    }
    else{
      this.notificationModel.defaultDomains = false;
      this.selectDomains = true;
    }
  }

  GetNotifDomains(t){

    t.setLoading(true);
    t.domainService.GetDomains()
    .then((resp) => {
      resp.data.forEach(domain => {
        t.notificationModel.selectedDomains.forEach(notifId => {
          if(domain.id == notifId){
            domain.selected = true;
          }else if(domain.selected != true) domain.selected = false;
        });
      });
      t.domains = resp.data;
      t.setLoading(false);
    })
    .catch((error)=>{
      t.notifier.notify('error', "Ошибка при получении списка доменов");
      t.setLoading(false);
    });
  }

  GetDomains(){
    this.setLoading(true);
    this.domainService.GetDomains()
    .then((resp) => {
      this.domains = resp.data;
      this.domains.forEach(dom => { dom.selected = true; });
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении списка доменов");
      this.setLoading(false);
    });
  }

  CheckedDomains(){
    this.domains.forEach(domain => {
      this.notificationModel.selectedDomains.forEach(notifId => {
        if(domain.id == notifId){
          domain.selected = true;
        }else if(domain.selected != true) domain.selected = false;
      });
    });
  }

  get headTextNotification() { return this.newNotificationForm.get('headTextNotification'); }
  get textNotification() { return this.newNotificationForm.get('textNotification'); }
  get linkNotification() { return this.newNotificationForm.get('linkNotification'); }
  get typeNotification() { return this.newNotificationForm.get('typeNotification'); }
  get beginDateForSendNotification() { return this.newNotificationForm.get('beginDateForSendNotification'); }
  get timeLiveNotification() { return this.newNotificationForm.get('timeLiveNotification'); }
  get btFileInfo1Notification() { return this.newNotificationForm.get('btFileInfo1Notification'); }
  get btFileInfo2Notification() { return this.newNotificationForm.get('btFileInfo2Notification'); }
  get btFileInfo1Name() { return this.newNotificationForm.get('btFileInfo1Name'); }
  get btFileInfo2Name() { return this.newNotificationForm.get('btFileInfo2Name'); }
  get hourNotification() { return this.newNotificationForm.get('hourNotification'); }
  get nidNotification() { return this.newNotificationForm.get('nidNotification'); }
  get ttlNotification() { return this.newNotificationForm.get('ttlNotification'); }
  get geoNotification() { return this.newNotificationForm.get('geoNotification'); }



  public goBack() {
    this.router.navigateByUrl("app/push-notification");
  }

  public uploadFile1 = (files) => {
    if (files.length === 0) {
      return;
    }

    this.btFileInfo1click = false;
    this.isloadedbtFileInfo1 = true;
    this.newbtFileInfo1 = <File>files[0];
    this.notificationModel.btFileInfo1Name = this.newbtFileInfo1.name;

    if(!this.accessFormat.includes(this.newbtFileInfo1.type)){
      this.notificationModel.newbtFileInfo1 = undefined;
      this.notificationModel.btFileInfo1Name = undefined;
      this.notifier.notify('error', "Неверный формат файла");
      return;
    }

    if(this.newbtFileInfo1.size > 204800){
      this.notificationModel.newbtFileInfo1 = undefined;
      this.notificationModel.btFileInfo1Name = undefined;
      this.notifier.notify('error', "Максимальный размер 200 КБ");
      return;
    }

    if (files && files[0]) {
      var reader = new FileReader();
      var t = this;
      reader.onload = function (e) {
        var img = new Image;
        img.src = <string> (<any>e).target.result;

        img.onload = () => {
          var imgWidth = img.width;
          var imgHeight = img.height;

          if(imgWidth == 128 && imgHeight == 128){
            $('#myShowImage1')
            .attr('src', (<any>e).target.result);

          } else {
            t.notificationModel.newbtFileInfo1 = undefined;
            t.notificationModel.btFileInfo1Name = undefined;
            t.notifier.notify('error', "Картинка должна быть размером 128х128");
          }
        };


      };

      reader.readAsDataURL(files[0]);
    }
  }

  public uploadFile2 = (files) => {
    if (files.length === 0) {
      return;
    }

    this.btFileInfo2click = false;
    this.newbtFileInfo2 = <File>files[0];
    this.notificationModel.btFileInfo2Name = this.newbtFileInfo2.name;
    this.isloadedbtFileInfo2 = true;

    if(!this.accessFormat.includes(this.newbtFileInfo2.type)){
      this.notificationModel.newbtFileInfo2 = undefined;
      this.notificationModel.btFileInfo2Name = undefined;
      this.notifier.notify('error', "Неверный формат файла");
      return;
    }

    if (files && files[0]) {
      var reader = new FileReader();
      var t = this;
      reader.onload = function (e) {
        // if(t.newbtFileInfo2.size <= 204800){
          $('#myShowImage2')
          .attr('src', (<any>e).target.result);

        // } else {
        //   t.notificationModel.newbtFileInfo2 = undefined;
        //   t.notificationModel.btFileInfo2Name = undefined;
        //   t.notifier.notify('error', "Максимальный размер 200 КБ");
        // }

      };

      reader.readAsDataURL(files[0]);
    }
  }


  public saveImage(_newbtFileInfo: any, _btFileInfoName: string, btFileInfoName: string): Promise<void> {
    var me = this;
    if (!this.newNotificationForm.valid) {
      return new Promise((resolve, reject) => {
        reject(`Форма не валидна`)
      });
    }
    if (!_newbtFileInfo) {
      return new Promise((resolve, reject) => {
        resolve()
      });
    }
    let formData = new FormData();
    formData.append('file', _newbtFileInfo, _newbtFileInfo.name);
    return this.uploadService.uploadFile(formData, "pushimage").then((resp) => {
      // this.notifierService.notify('success', "Файл " + _btFileInfoName + " загружен");
      this.notificationModel[btFileInfoName] = resp.data;
    })
      .catch((error) => {
        this.notifierService.notify('error', 'Не удалось загрузить файл ' + _btFileInfoName);
      });
  }

  public saveNotification() {
    var me = this;
    if(me.notificationModel.headText != undefined)me.notificationModel.headText = me.notificationModel.headText.trim();
    if(me.notificationModel.text != undefined)me.notificationModel.text = me.notificationModel.text.trim();
    if(me.notificationModel.link != undefined)me.notificationModel.link = me.notificationModel.link.trim();
    if (!this.newNotificationForm.valid) {
      this.markFormGroupTouchedAndDirty(this.newNotificationForm);
      // this.isloadedbtFileInfo2 = true;
      this.isloadedbtFileInfo1 = true;

      this.notifierService.notify('error', 'Проверьте корректность данных');
      return;
    }

    var j = 0;
    me.notificationModel.selectedDomains = [];
    this.domains.forEach(dom => {
      if(dom.selected == true){
        me.notificationModel.selectedDomains[j] = dom.id;
        j++;
      }
    });
    me.setLoading(true);
    Promise.all([
      me.saveImage(me.newbtFileInfo1, me.notificationModel.btFileInfo1Name, "btFileInfo1Id"),
      me.saveImage(me.newbtFileInfo2, me.notificationModel.btFileInfo2Name, "btFileInfo2Id")
    ])
      .then(response => {
        if (!me.notificationModel.btFileInfo2Name) me.notificationModel.btFileInfo2Id = null;
        me.pushNotificationService.createOrEditNotification(me.notificationModel)
          .then((resp) => {
            if (resp) {
              this.notifierService.notify('success', 'Успешно сохранено');
              this.router.navigateByUrl("app/push-notification");
            }
            else {
              this.notifierService.notify('error', 'Ошибка при сохранении уведомления');

            }
            this.setLoading(false);
          })
          .catch((er) => {
            var text = this.GetErrorMessageText("Не удалось сохранить данные уведомления", er);
            this.notifier.notify('error', text);
            this.setLoading(false);
          })
      })
      .catch(error => {
        this.notifierService.notify('error', 'Ошибка загрузки картинок');
        this.setLoading(false);

      })


  }

  public loadNotification(id: string) {
    var t = this;
    t.setLoading(true);

    t.pushNotificationService.getNotification(id)
      .then((resp) => {
        t.notificationModel = resp.data;
        t.setLoading(false);
        this.selectDomains = !this.notificationModel.defaultDomains;
        t.GetNotifDomains(t);
        t.notificationModel = JSON.parse(JSON.stringify(t.notificationModel));
        $('#myShowImage1').attr('src', apiUrl + t.notificationModel.virtualPath1)
        $('#myShowImage2').attr('src', apiUrl + t.notificationModel.virtualPath2)

      })
      .catch((error) => {
        t.notifierService.notify('error', 'Ошибка подгрузки данных');
        t.router.navigateByUrl("app/push-notification");
        t.setLoading(false);
      });
  }

  public getRole():number {
		return this.userService.getRole();
	}

}



// WEBPACK FOOTER //
// ./src/app/push-notification/push-notification-editor/push-notification-editor.component.ts